import styled from "styled-components";

export const Men = styled.div`
color: #fff;
min-height: 80vh;
input[type='radio']{
  display: none;
}
label{
  cursor: pointer;
  position: relative;
 
}
label h5{
  position: absolute;
  background-color: #00000099;
  border-radius: 3px;
  padding: 0px 3px;
  transform: translateX(-50%);
  left: 50%;
  bottom: 0px;
}
label img{
  border-radius: 5px;
}
.menus-wrap{
    margin: 25px;
    display: flex;
    justify-content: center;
}
.menus{

    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}
.menus div{
  margin: 15px;
}
._top{
  display: flex;
  justify-content: space-between;
}
.items{
  display: flex;
  justify-content: center;
}
.items ul{
  padding: 0px;
}
.items ul li div{
  
  display: flex;
}
.items ul li div img{
  align-self: center;
  border-radius: 3px;
}
.items ul li h6{
  color: red;
  margin: 3px 0px;
}
.items ul li div p{
  font-weight: 400;
  margin: 0px;
  margin-left: 15px;
  align-self: center;
}
li a{
  color: #2f4f20;
  text-decoration: none;
}
li{
  max-width: 500px;
  padding: 5px 15px;
  margin: 20px 10px;
  border-radius: 3px;
  list-style: none;
  background-color: #fff;
  color: #3f4f4f;
}

`